/** Alfabeto sin caracteres ambiguos: sin 0/O, sin 1/l/I/i, sin o. */
export const TEMP_PASSWORD_ALPHABET = 'abcdefghjkmnpqrstuvwxyz23456789';

/**
 * Clave temporal con formato `treid-####` (4 caracteres del alfabeto seguro).
 * `rand` inyectable para tests deterministas.
 */
export function generateTempPassword(rand: () => number = Math.random): string {
  let suffix = '';
  for (let i = 0; i < 4; i++) {
    const index = Math.min(
      TEMP_PASSWORD_ALPHABET.length - 1,
      Math.floor(rand() * TEMP_PASSWORD_ALPHABET.length),
    );
    suffix += TEMP_PASSWORD_ALPHABET[index];
  }
  return `treid-${suffix}`;
}
